import React from 'react';
import PropTypes from 'prop-types';

const Radio = ({ checked, value, label, id, onChange, name }) => (
  <div className='form-check'>
    <input className='form-check-input' type='radio' name={name} id={id || value} value={value} checked={checked} onChange={onChange} />
    <label className='form-check-label' htmlFor={id || value}>
      {label || value}
    </label>
  </div>
);

export default Radio;

Radio.propTypes = {
  checked: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  id: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/common/forms/Radio/index.js